import React from 'react';
import { enumHelper } from '../../utils';
import enums from '../../enums/index';

export const completedReservesReportColumns = [
  {
    title: 'ردیف',
    isRowNumber: true,
  },
  {
    title: 'نام کافه',
    dataIndex: 'cafeName',
    name: 'cafeName',
    isSortable: false,
  },
  {
    title: 'نام مشتری',
    dataIndex: 'createdFullName',
    name: 'createdFullName',
    isSortable: false,
  },
  {
    title: 'تعداد نفرات',
    dataIndex: 'persons',
    name: 'persons',
    isSortable: false,
  },
  {
    title: 'مبلغ پیش پرداخت',
    dataIndex: 'cafeBasePrice',
    name: 'cafeBasePrice',
    isSortable: false,
    render: text => <div>{Number(text).toLocaleString()}</div>,
  },
  {
    title: 'مبلغ ورودی',
    dataIndex: 'totalEntranceAmount',
    name: 'totalEntranceAmount',
    isSortable: false,
    render: text => <div>{Number(text).toLocaleString()}</div>,
  },
  {
    title: 'تخفیف کافه',
    dataIndex: 'cafeDiscountAmount',
    name: 'cafeDiscountAmount',
    isSortable: false,
    render: cafeDiscountAmount => (
      <div className={`direction-ltr`}>
        {Number(cafeDiscountAmount).toLocaleString()}
      </div>
    ),
  },
  {
    title: 'تخفیف آرسی',
    dataIndex: 'rseeDiscountAmount',
    name: 'rseeDiscountAmount',
    isSortable: false,
    render: rseeDiscountAmount => (
      <div className={`direction-ltr`}>
        {Number(rseeDiscountAmount).toLocaleString()}
      </div>
    ),
  },
  {
    title: 'کد تخفیف',
    dataIndex: 'discountCodeAmount',
    name: 'discountCodeAmount',
    isSortable: false,
    render: discountCodeAmount => (
      <div className={`direction-ltr`}>
        {Number(discountCodeAmount).toLocaleString()}
      </div>
    ),
  },
  {
    title: 'شماره میز',
    dataIndex: 'reservedTables',
    name: 'reservedTables',
    isSortable: false,
    render: (reservedTables = []) => (
      <div className={`direction-ltr`}>
        {reservedTables?.map(x => x.num).join('، ')}
      </div>
    ),
  },
  // {
  //   title: 'ساعت رزرو',
  //   dataIndex: 'reservedTables.fromTime',
  //   name: 'reservedTables.fromTime',
  //   isSortable: true,
  //   render: (reservedTables) => (
  //     <div className={`direction-ltr`}>{reservedTables.map(x => `${x.fromTime}__${x.toTime}`).join(', ')}</div>),
  // },
  {
    title: 'کد رزرو',
    dataIndex: 'trackingNumber',
    name: 'trackingNumber',
    isSortable: false,
    render: trackingNumber => (
      <div className={`direction-ltr`}>{trackingNumber}</div>
    ),
  },
  {
    title: 'تاریخ شروع رزرو',
    dataIndex: 'date',
    name: 'date',
    isSortable: false,
  },
  {
    title: 'تاریخ پایان رزرو',
    dataIndex: 'endAt',
    name: 'endAt',
    isSortable: false,
  },
  {
    title: 'درصد سهم آرسی',
    dataIndex: 'rseePercent',
    name: 'rseePercent',
    isSortable: false,
    render: rseePercent => (
      <div className={`direction-ltr`}>
        {Number(rseePercent).toLocaleString()}
      </div>
    ),
  },
  {
    title: 'مبلغ سهم آرسی',
    dataIndex: 'rseeStockAmount',
    name: 'rseeStockAmount',
    isSortable: false,
    render: rseeStockAmount => (
      <div className={`direction-ltr`}>
        {Number(rseeStockAmount).toLocaleString()}
      </div>
    ),
  },
  {
    title: 'بالانس',
    dataIndex: 'balanceAmount',
    name: 'balanceAmount',
    isSortable: false,
    render: balanceAmount => (
      <div className={`direction-ltr`}>
        {Number(balanceAmount).toLocaleString()}
      </div>
    ),
  },
  {
    title: 'وضعیت رزرو',
    dataIndex: 'status',
    name: 'status',
    isSortable: false,
    render: status => (
      <div className={`direction-ltr`}>
        {enumHelper.convertEnumValueToTitle(
          enums.CAFE_RESERVATION.list,
          status,
        )}
      </div>
    ),
  },
];
